import "./accordion_component.scss"